
export default class Calculator {
  constructor() {}

  //Stats Maths
  doStatsMath(op,a){
    var statoperation = null;
    switch (op) {
      case "sdev":
        statoperation = this.sdev;
        break;
      case "median":
        statoperation = this.median;
        break;
      case "mode":
        statoperation = this.mode;
        break;
      case "mean":
      default:
        statoperation = this.mean;
    }
    return statoperation(a);
  }
  mean(a) {
    var total = 0;
    var amount = 0;
    for(var i=0; i<a.length; i++) 
    { 
      total += a[i]; 
      amount++;
    }
    return total/amount ;
  }
  median(values) {
    if(values.length ===0) return 0;

    values.sort(function(a,b){
      return a-b;
    });
  
    var half = Math.floor(values.length / 2);
  
    if (values.length % 2)
      return values[half];
  
    return (values[half - 1] + values[half]) / 2.0;
  }
  mode(arr) {
    var numMapping = {};
    var greatestFreq = 0;
    var mode;
    arr.forEach(function findMode(number) {
        numMapping[number] = (numMapping[number] || 0) + 1;

        if (greatestFreq < numMapping[number]) {
            greatestFreq = numMapping[number];
            mode = number;
        }
    });
    return +mode;
  }
  sdev(a) {
    var totala = 0;
    var amounta = 0;
    for(var i=0; i<a.length; i++) 
    { 
      totala += a[i]; 
      amounta++;
    }
    var av =  totala/amounta ;
    var total = 0;
    var amount = 0;
    var ret = 0
    for(var i=0; i<a.length; i++) 
    { 
      total += Math.pow(a[i] - av,2); 
      amount++;
    }
    amount--;
    ret = Math.sqrt((total/(amount)));

    return ret;

  }


  //Simple Math
  doMath(op, a, b) {
    var operation = null;
    switch (op) {
      case "sub":
        operation = this.sub;
        break;
      case "multi":
        operation = this.multiply;
        break;
      case "div":
        operation = this.divide;
        break;
      case "add":
      default:
        operation = this.add;
    }

    return operation(a, b);
  }
  add(a, b) {
    return a + b;
  }
  sub(a, b) {
    return a - b;
  }
  multiply(a, b) {
    return a * b;
  }
  divide(a, b) {
    return a / b;
  }


}
